var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneSquareAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 13.484 14 12.36c-.047 0-.14 0-.188-.046-.187.046-.374.14-.468.234l-1.172 1.406c-1.547-.703-3.422-2.578-4.125-4.125l1.406-1.172c.094-.094.188-.281.235-.469-.047-.046-.047-.14-.047-.187L8.516 5.375C8.422 5.187 8.187 5.047 8 5c-.047.047-.094.047-.14.047l-2.438.562A.55.55 0 0 0 5 6.125 10.853 10.853 0 0 0 15.875 17a.55.55 0 0 0 .516-.422l.562-2.437c0-.047 0-.094.047-.141-.047-.188-.188-.422-.375-.516ZM19.25.5H2.75A2.25 2.25 0 0 0 .5 2.75v16.5c0 1.266.984 2.25 2.25 2.25h16.5a2.25 2.25 0 0 0 2.25-2.25V2.75C21.5 1.531 20.469.5 19.25.5Zm0 18.469c0 .187-.14.281-.281.281H3.03c-.187 0-.281-.094-.281-.281V3.03c0-.14.094-.281.281-.281H18.97c.14 0 .281.14.281.281V18.97Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneSquareAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-square-alt.f2454bfeeb7f61cd3c8e408e768ee4cd.svg";